<template>
  <div id="app">
    <!-- 提示页面 -->
    <app-tips 
    :tipInfo="tipInfo" 
    :btnshow="btnshow"
    :btnreload="btnreload"
    :btnpay="btnpay"
    :imei="imei"
    @tipShow="tipShow" 
    @countinuePay="countinuePay"
    v-show="tipshow"></app-tips>
   <!-- Mqtt确认货机是否在线-->
   <!-- 进入页面遮罩 -->
   <app-machine-alive  v-if="machine_alive" @machineStatus="machineStatus"></app-machine-alive>
   <app-mqtt :imei="imei" :server_url="server_url" @machineStatus="machineStatus" ref="mychild"></app-mqtt>
   <!-- 头部-->
   <app-header :headInfo="headInfo" :shopInfo="shopInfo" :imei="imei" :head="head"></app-header>
   <!-- 导航 -->
   <app-nav :commentNum="commentNum" :imei="imei" :server_url="server_url" :pickup = "pickup"></app-nav> 
   <!-- 货机状态 -->
   <app-m-status v-if="machinestatus" :mqttShow="mqttShow"></app-m-status>
   <!-- 商户状态 -->
   <app-check-page v-if="checkPage" :message="checkMessage"></app-check-page>
   <!-- 内容 -->
   <keep-alive>
      <router-view 
      @selectGoods="selectGoodsPay" 
      @showTip="showTip" 
      @showMessage="showMessage"
      @chooseGoods = "handleChooseGoods"
      :imei="imei"
      :server_url="server_url"
      :cartType = "cartType"
      :shopInfo = "shopInfo"
      :bsoll = "bsoll"
      :c_num = "c_num"
      :cartNum = "cartNum"
      :lock="lock"
      :lock_times="lock_times"
      :head="head"
      v-if="multi_page"
      ></router-view>
   </keep-alive>
   <!-- 确认订单 -->
  <order-page 
    v-if="order_page"
    :orderInfo="orderInfo"
    :imei="imei"
    :server_url="server_url"
    :c_num = "c_num"
    :show_back = "multi_page"
    :source="source"
    :showPayBtn="showPayBtn"
    :lock="lock"
    :lock_times="lock_times"
    :freight_way_type="freight_way_type"
    @confirm="handleConfirm"
    @back="handleBack"
    @showMessages="showMessage"
  ></order-page>
  <!-- 购物车支付页面 -->
  <pay-page
    v-if="pay_page"
    :cartOrderInfo="cartOrderInfo"
    :imei="imei"
    :server_url="server_url"
    :show_back = "multi_page"
    :source="source"
    :showPayBtn="showPayBtn"
    :lock="lock"
    :lock_times="lock_times"
    @confirm="handleConfirm"
    @back="handleBack"
    @showMessages="showMessage"
  ></pay-page>
  </div>
</template>

<script>
import Mqtt from './components/Mqtt/Mqtt'
import Header from './components/Header/Header'
import Nav from './components/Nav/Nav'
import machinestatus from './components/machinestatus/machinestatus'
import checkPage from './components/checkPage/checkPage'
import Tips from './components/tips/Tips'
import Questionnaire from './components/questionnaire/Questionnaire'
import MachineAlive from './components/tips/MachineAlive'
import orderPage from './components/orderPage/orderPage'
import payPage from './components/payPage/payPage'
export default {
  name: 'App',
  components:{
      "app-mqtt":Mqtt,
      "app-header":Header,
      "app-nav":Nav,
      "app-m-status":machinestatus,
      "app-check-page":checkPage,
      "app-tips":Tips,
      "questionnaire": Questionnaire,
      "app-machine-alive":MachineAlive,
      "order-page":orderPage,
      "pay-page":payPage,
  },
  data(){
    return{
      head:false,
      poiInfo:{},
      commentNum:0,
      headInfo:{},//头部轮播图信息
      orderInfo:{
        No:'',
        key:'',
        capacity:'',
        goods_id:'',
        machine_id:'',
        merchantId:'',
        goods:{
          goodsId:'',
          goodsImage:'',
          goodsName:'',
          goodsPrice:'',
          goodsUnit:''
        }
      },//确认订单信息
      cartOrderInfo:{},//购物车订单信息
      putOrderInfo:{
            appId:"",
            openid:"",
            source: 0,
            machine_id:"",
            check:true,
            goods_list:[]
      },//提交的订单信息
      mqttShow: '',
      shopInfo:{},//货机信息
      tipInfo:"",
      cartType:0, //购物车是否启用  1启用   0关闭
      cartNum: 4, //购物车商品数量
      app_id: '', //微信小程序id
      tipshow: false,
      btnshow: true,
      btnreload: false,
      btnpay: false,
      closebtn: false, //提示页面关闭
      tipReload:false,//tips页面是否刷新页面
      machine_alive:true,
      machinestatus:false,
      commentNum:0,
      source:0,//入口  微信 WeiXIN  支付宝 Alipay
      multi_page:true,//选择商品 true为开启  false为关闭  与order_page 配合使用
      order_page:false,  //确认订单页面 扫描货道 true为开启  false为关闭   与multi_page 配合使用
      pay_success_page:false,  //支付成功页面
      pay_page:false,   //同上
      pay_fail_page:false,  //支付失败页面
      pay_await_page:false,  //支付查询页面
      goods_push_page:false,  //等待出货页面
      goods_push_success_page:false,  //出货成功页面
      goods_push_fail_page:false,  //出货失败页面
      machineId:"",//货机id
      imei:"",
      freight_way:"", //货道号
      freight_way_type: 0, //货道状态
      aisle_code:"", //用户code
      openid:"",//用户openid
      nickname: "", //用户昵称
      avatar: "", //用户头像图片地址
      user_id:"",//用户userid
      state:"",//跳转后带的参数
      bankRequestNum:"",  //银行流水号
      orderNum:"",  //订单号
      requestNum:"",  //请求编号
      res:{},
      showPayBtn:true,
      pay_url: '', //支付url
      bsoll:false, //商品滚动
      putUserInfo:{
        source: '',
        code: '',
        app_id: ''
      }, //提交获取用户openid
      checkPage: false,
      checkMessage: '',
      question: false, //调查问卷
      pickup: '0', //是否显示取货码功能  0不显示  1显示
      c_num: '', //c端表示码
      lock: '1', //是否开启库存锁定  0不锁定  1开启锁定
      lock_times: 60, //开始锁定后的锁定库存的时间,
      timerId:0,  //定时器id,
      home_url: 'https://shopmerge.hrcc7.com', //首页url""  http://192.168.1.246:8081,
      server_url: 'https://home.hrcc7.com', //服务端url http://hv3
    }
  },

  created(){
    if(this.$route.query.imei){
      this.imei = this.$route.query.imei
    }
    if(this.$route.query.freight_way){
        this.freight_way = this.$route.query.freight_way
        this.freight_way_type = 1;
    }
    if(this.$route.query.open_id){
        this.openid = this.$route.query.open_id
        this.c_num = this.$route.query.open_id
    }
    if(this.$route.query.appid){
        this.appId = this.$route.query.appid
    }
    //加入排队
    //fetch("https://home.hrcc7.com/server/c/checkMerchant?imei="+this.imei)
    fetch(this.server_url+"/server/c/merge_lock?imei="+this.imei+"&openid="+this.openid)
    .then(res => {
        return res.json()
      })
    .then((res) =>{
      if(res.code == 1000){
        this.tipInfo = res.msg;
        this.tipshow = true;
        this.btnshow = false;
        setTimeout(function(){
          window.opener=null;
          window.close();
        },3000)
        return ;
      }
    })
    var that = this
    // 设置定时器 实现扫码付排队购买 每隔5s执行1次
    this.timerId = setInterval(() => {
      fetch(this.server_url+"/server/c/merge_lock?imei="+that.imei+"&openid="+that.openid)
      .then(res => {
        return res.json()
      })
      .then((res) =>{
        if(res.code == 1000){
          that.tipInfo = res.msg;
          that.tipshow = true;
          that.btnshow = false;
          return ;
        }
      })
    }, 5000);
    console.log('timerId')
    console.log(this.timerId)
    //30s后关闭定时器
    setTimeout(function(){
      console.log(that)
      clearInterval(that.timerId);
      console.log('timerId')
      console.log(that.timerId)
    },6000) 
    

    //识别扫描入口
    var ua = window.navigator.userAgent.toLowerCase();
    if ( ua.match(/MicroMessenger/i) == 'micromessenger' ) {  
          //判断是不是微信
          this.source = 1;
    } else if (ua.match(/AlipayClient/i) == 'alipayclient') {
        //判断是不是支付宝
        this.source = 2;
    } else {
        //哪个都不是退出
        this.tipInfo = "请使用微信或支付宝扫码，谢谢！";
        this.tipshow = true;
        this.btnshow = false;
        setTimeout(function(){
          window.opener=null;
          window.close();
        },3000)
        return ;
    }
    
    // //生成C端标识码
    // this.c_num = this.openid
    // console.log(this.c_num)

    //头部图片
    fetch(this.server_url+"/server/c/header?imei="+this.imei)
      .then(res => {
        return res.json()
      })
      .then(response =>{
        if(response.code == 2000){
          console.log('头部图片')
          console.log(response.data)
          if(response.data != [] || response.data != null){
            this.headInfo = response.data
            this.head = true
          } else {
            this.head = false
          }
        }else{
          this.head = false
        }
        console.log("head的值" + this.head)
      })


    //获取商户信息
    fetch(this.server_url+"/server/c/machine_info/?imei="+this.imei)
      .then(res => {
        return res.json()
      })
      .then((res) =>{
        if(res.code == 2000){ 
          if(res.data.machine.name == undefined){
            res.data.machine.name = "无人售货机"
          }else{
            if(res.data.machine.name == ""){
              res.data.machine.name = "无人售货机"
            }
            
            //判断商户是否配置了支付账户信息，如果没有配置则提示客户
          }
          this.shopInfo = res.data
          this.pickup = res.data.machine.pickup
          console.log(this.shopInfo)
          //调用mqtt获取设备状态
          //if(this.aisle_code != ""){
            if(this.imei != ''){
              console.log('传入的imei'+this.imei)
              this.$refs.mychild.testOnLine(this.imei)
            }
          //}
          //console.log(this.imei)
          //根据商户设定来开启0或关闭购物车1
          this.cartType = res.data.machine.is_cart
          
          //判断是否有app头标题信息
          if(res.data.machine.title == undefined)
          {
            document.title = "恒瑞成";
          }else{
            document.title = res.data.machine.title;
          }
          //获取商户设置信息
          //this.lock = res.data.machine.lock_stock
          //this.lock_times = res.data.merchant.lock_times
          this.cartNum = res.data.machine.android_cart_goods_num
          console.log(this.lock)
          console.log(this.lock_times)
        } else {
            // 异常提示
            this.checkMessage = res.msg
            this.checkPage = true
            this.multi_page = false
            return
        }
      })

    //   //如果是单货道扫码
    //   if(this.freight_way != ""){
    //     //访问单货道商品接口然后将相关信息推送到页面
    //     fetch("https://home.hrcc7.com/server/c/one_goods?imei="+this.imei+"&freight_way="+this.freight_way)
    //     .then(res => {
    //       return res.json()
    //     })
    //     .then(response =>{
    //       if(response.code == 0){ 
    //         this.orderInfo = response.data
    //         //添加货道信息
    //         let info = {};
    //         let p_info = Array();
    //             p_info[0]='{"key":'+this.orderInfo['key']+',"count":1,"goods_id":'+this.orderInfo['goods_id']+',"price":'+this.orderInfo['price']+'}';
    //             // p_info[0]={
    //             //       "No":this.orderInfo['No'],
    //             //       "count":1,
    //             //       "goods_id":this.orderInfo['goods_id'],
    //             //       "price":this.orderInfo['price']
    //             //     };
    //         info['total_price'] = this.orderInfo['price'];
    //         info['total_count'] = 1;
    //         info['key_list'] = this.orderInfo['key'];
    //         info['machine_id'] = this.orderInfo['machine_id'];
    //         info['merchant_id'] = this.orderInfo['merchant_id'];
    //         info['goods'] = '['+p_info+']';
    //         this.cartOrderInfo = info;
    //         //console.log(this.cartOrderInfo)
    //       }else if(response.code == 404){
    //         this.machineDown()
    //       }else if(response.code == 405){
    //         this.machineOver()
    //       }else{
    //         //alert("获取单货道数据出现错误！")
    //         this.tipInfo = "获取单货道数据出现错误！";
    //         this.tipshow = true;
    //         this.btnshow = false;
    //         setTimeout(function(){
    //           window.opener=null;
    //           window.close();
    //         },3000)
    //         return;
    //       }
    //     })

    //     this.multi_page = false
    //     this.order_page = true
    // }
    
  },
  methods: {
    showTip(info){
      //console.log(info)
      this.tipInfo = info
      this.tipshow = true
      
    },
    showMessage(info){
      this.tipInfo = info
      this.tipshow = true
      this.btnshow = false
    },
    tipShow(){
      this.tipshow = false
      if(this.tipshow == false){
        for(let i=0 ;i < 1000; i++){
          clearInterval(i);
        }
      }
      if(this.tipReload){
        //刷新页面
        location.replace(this.home_url+'/?imei=' + this.imei + '&appid=' + this.appId + '&open_id=' + this.openid)

      }
    },
    countinuePay(){
      console.log('continuePay');
      this.tipshow = false;
      this.putOrderInfo.check = false;
      //this.handleConfirm();
    },
    machineDown: function(){
      //alert("当前设备已离线！");
      this.tipInfo = "当前设备已离线！";
      this.tipshow = true;
      this.btnshow = false;
      setTimeout(function(){
        window.opener=null;
        window.close();
      },3000)
      return
    },
    machineOver: function(){
      //alert("当前设备已过期！");
      this.tipInfo = "当前设备已过期！";
      this.tipshow = true;
      this.btnshow = false;
      setTimeout(function(){
        window.opener=null;
        window.close();
      },3000)
      return
    },
    handleChooseGoods: function(that){ //不带购物车的时候获取订单数据
      this.orderInfo = that
      console.log(this.orderInfo)
      //添加货道信息
      let info = {};
      let p_info = Array();
          p_info[0]='{"key":"'+that.key+'","count":1,"goods_id":'+that.goods_id+',"price":'+that.price+'}';
          // p_info[0]={
          //       "No":that['No'],
          //       "count":1,
          //       "goods_id":that['goods_id'],
          //       "price":that['price']
          //     };
      info['total_price'] = that.price;
      info['goods_name_list'] = that.freight_name;
      info['total_count'] = 1;
      info['key_list'] = that.key;
      info['machine_id'] = that.machine_id;
      info['merchant_id'] = that.merchant_id;
      info['goods'] = '['+p_info+']';
      info['goods_id'] = that['goods_id'];
      this.cartOrderInfo = info;
      //console.log(this.cartOrderInfo)
      this.multi_page = false
      this.order_page = true
    },
    handleConfirm: function(){
      //隐藏支付按钮
      this.showPayBtn = false
      this.pay()
    },
    pay(){
        //将信息插入orderInfo中
        if(this.cartType == 1){
          this.putOrderInfo.openid = this.openid
          this.putOrderInfo.appId = this.appId
          this.putOrderInfo.source = this.source
          this.putOrderInfo.merchant_id = this.cartOrderInfo.merchant_id
          this.putOrderInfo.machine_id = this.cartOrderInfo.machine_id
          this.putOrderInfo.goods_list = this.cartOrderInfo.goods
          this.putOrderInfo.imei = this.imei
          //var url = "https://home.hrcc7.com/server/c/merage/orderCart" //下单接口
          var url = this.server_url+"/server/c/merge_orderCart" //下单接口
        }
        if(this.cartType == 0){
          this.putOrderInfo.goods_id = this.cartOrderInfo.goods_id
          this.putOrderInfo.imei =  this.imei
          this.putOrderInfo.key = this.orderInfo.key
          this.putOrderInfo.openid = this.openid
          this.putOrderInfo.appId = this.appId
          this.putOrderInfo.merchant_id = this.cartOrderInfo.merchant_id
          this.putOrderInfo.source = this.source
          //var url = "https://home.hrcc7.com/server/c/merage/order" //下单接口
          var url = this.server_url+"/server/c/merge_order" //下单接口
        }
        console.log(this.putOrderInfo)
        this.axios.post(   //请求方式
        url,  //接口地址
        this.putOrderInfo
        )    //传递参数 
        .then(response =>{
            if(response.data.code == 2000){
              var a = document.createElement("a");
                  a.setAttribute("href", response.data.data.url);
                  // a.setAttribute("target", "_blank");
                  a.click();
            }else{
              this.tipInfo = response.data.msg;
              this.tipshow = true;
            }
        })
        .catch((error) => {
            //console.log(error)
            //alert("非常抱歉，出现系统内部错误！")
            this.tipInfo = "非常抱歉，系统出现内部错误！"+error;
            //this.tipInfo = error;
            this.tipshow = true;
            //显示支付按钮
            this.showPayBtn = true
            for(let i=0 ;i < 1000; i++){
              clearInterval(i);
            }
        })
    },
    handleBack:function(){
        for(let i=0 ;i < 1000; i++){
          clearInterval(i);
        }
        this.order_page = false
        this.pay_page = false
        this.multi_page = true
        this.bsoll = true
        this.showPayBtn = true
        //location.reload()
        //location.replace('https://shopmerge.hrcc7.com/?imei=' + this.imei + '&open_id=' + this.openid + '&app_id=' + this.appId)
        location.replace(this.home_url+'/?imei=' + this.imei + '&open_id=' + this.openid + '&appid=' + this.appId)
      
    },
    fshowPayBtn: function(){
      this.showPayBtn = true
    },
    selectGoodsPay: function(that){  //带购物车的时候获取订单数据
      console.log(that);
      let info = {};
      let p_info = Array();
      let total_price = 0;
      let total_count = 0;
      let goods_name_list = "";
      let machine_id = "";
      let merchant_id = "";
      let operation_id = "";
      for(let i in that){
        //总价格
        let goods_price = 0;
        goods_price = Number(that[i]['price']) *Number(that[i]['count']);
        total_price += goods_price;
        //总商品数量
        total_count += that[i]['count'];
        //货道列表
        if(i ==0){
          goods_name_list = that[i]['freight_name'];
        }else{
          goods_name_list = goods_name_list +','+ that[i]['freight_name'];
        }
        //货机id
        machine_id = that[i]['machine_id'];
        //商户id
        merchant_id = that[i]['merchant_id'];
        //操作员id
        operation_id = that[i]['operation_id'];
        p_info[i] ='{"key":"'+that[i]['key']+'","count":'+that[i]['count']+',"goods_id":'+that[i]['goods_id']+',"price":'+that[i]['price']+'}';
        // p_info[i]={
        //             'No':that[i]['No'],
        //             'count':that[i]['count'],
        //             'goods_id':that[i]['goods_id'],
        //             'price':that[i]['price']
        //           };
      }
      total_price = Math.round(total_price*100)/100   //总价格四舍五入保留2位小数
      info['goods_id'] = 1;
      info['total_price'] = total_price;
      info['total_count'] = total_count;
      info['goods_name_list'] = goods_name_list;
      info['machine_id'] = machine_id;
      info['merchant_id'] = merchant_id;
      info['operation_id'] = operation_id;
      info['goods'] = '['+p_info+']';
      this.cartOrderInfo = info;
      console.log(info)
      this.multi_page = false
      this.pay_page = true
    },
    machineStatus: function(status,msg){
      if(status == "on"){
        this.machine_alive = false;
      }
      if(status == "off"){
        this.multi_page = false;
        this.machinestatus = true;
        this.mqttShow = msg;
        this.machine_alive = false;
      }
    }


  }
}
</script>

<style >
  body{
    margin-top: 0;
    margin-left: 0;
    margin-right: 0;
    margin-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue